<template>
  <div class="main-board">
    <game-info v-bind:score="score" v-bind:view="view" v-bind:roomName="room.title"></game-info>
    <card-area v-bind:room="room" v-bind:view="view"></card-area>
  </div>
</template>

<script>
import CardArea from './Card Area/CardArea.vue'
import GameInfo from './Game Info/GameInfo.vue'
export default {
  props: ["room", "score", "time", "info", "view"],
  components:{
    'card-area': CardArea,
    'game-info': GameInfo
  },
  data() {
    return {
      text:"MainBoard"
    }
  }
}
</script>
<style lang="stylus">
@require '../../styles/index'
.main-board
  max-width 1100px
  box-sizing border-box
  box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
  border-radius 30px
  margin 10px
  padding 20px
  background $color__background-board--default
  .dark-theme &
    background $color__background-board--dark-theme
</style>